import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import i18n from "../../../../Utils/i18next/i18next";
const { t } = i18n;
const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  registryRights: [],
  availableStatuses: null,
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [
      { key: "index", name: "global:secret.index" },
      {
        key: "client.name",
        name: "global:secret.client",
      },
      {
        key: "clientRepresentative.name, clientRepresentative.lastname",
        name: "global:secret.clientRepresentative",
      },
      {
        key: "customerServiceRepresentative.firstName, customerServiceRepresentative.lastName",
        name: "global:secret.customerServiceRepresentative",
      },

      { key: "status.name", name: "global:secret.status" },
    ],
    selectedSearchFields: [
      "index",
      "status.name",
      "client.name",
      "clientRepresentative.name, clientRepresentative.lastname",
      "customerServiceRepresentative.firstName, customerServiceRepresentative.lastName",
    ],
    dictionaryFields: [],
    url: "secret",
  },
};

const secretReducer = createSlice({
  name: "secretReducer",
  initialState,
  reducers: {
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    clearRegistry: () => initialState,
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
} = secretReducer.actions;

export default secretReducer.reducer;
